'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('reportspec', {
      url: '/reportspec',
      template: '<reportspec></reportspec>'
    });
}
